// Ürün Ağacı sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'production.tree';

export const productionTreeGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Ürün Ağacı nasıl okunur?'),
  intro: t(`${G}.intro`, 'Ürün ağacı, bir mamulün reçetesini tüm alt seviyeleriyle (yarı mamuller ve hammaddeler) ve maliyetiyle gösterir. Bu ekran yalnız gösterir; reçete burada değişmez, stoğa dokunulmaz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Ürün ağacı / Nerede kullanılıyor'),
    filters: t(`${G}.regions.filters`, 'Ürün, miktar, şube'),
    stats: t(`${G}.regions.stats`, 'Maliyet özeti'),
    toolbar: t(`${G}.regions.toolbar`, 'Tümünü aç / kapat, Excel'),
    table: t(`${G}.regions.table`, 'Ağaç tablosu'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Mamulü ve miktarı seçin'),
      text: t(`${G}.s1.text`, '"Ürün ağacı" görünümünde "Ürün" listesinden reçetesi olan ürünü seçin ve "Miktar"ı yazın; tüm satırlar bu miktara göre hesaplanır. Şube varsa "Şube" ile maliyeti o şubenin alış fiyatlarıyla görebilirsiniz; "Şirket geneli fiyat" şirket fiyatlarını kullanır.'),
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Maliyet özetini okuyun'),
      text: t(`${G}.s2.text`, 'Ürün adının yanında üretim şekli (Stoğa üretim / Satışta düşüm), altında reçetenin kaç birim için tanımlı olduğu, "Standart birim maliyet" ve seçtiğiniz miktar için "Toplam maliyet" yazar.'),
      tips: [
        t(`${G}.s2.tip1`, 'Sarı uyarılar döviz maliyetlerinin çevrilmediğini, bir reçetenin üst seviyede tekrar ettiğini ya da derinliğin 10 seviyeyi aştığını belirtir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Ağacı okuyun'),
      text: t(`${G}.s3.text`, 'Her satır bir malzemedir: Seviye, Miktar, Birim, Fire %, Tüketim, Birim maliyet, Tutar ve Pay % (toplam maliyete oranı). Alt seviyesi olan satırı ok ile açıp kapatabilirsiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Miktar, reçete miktarına fire % eklenip seçtiğiniz üretim miktarına oranlanarak bulunur.'),
        t(`${G}.s3.tip2`, 'Tüketim sütunu: "Açılır" — satışta ve üretimde alt malzemeleri düşülür. "Stoktan" — yarı mamul stoğundan düşülür, alt malzemeler bilgi amaçlı gösterilir. "Ham madde" — kendi reçetesi yoktur. "(satır istisnası)" bu davranışın reçete satırında değiştirildiğini gösterir.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s4.title`, '4. Tümünü açın veya Excel\'e aktarın'),
      text: t(`${G}.s4.text`, '"Tümünü aç" bütün seviyeleri açar, "Tümünü kapat" kapatır; 2000\'den fazla satır açılacaksa tablonun yavaşlayabileceği uyarısı çıkar. "Excel\'e aktar" ağacı dosyaya indirir.'),
    },
    {
      region: 'header',
      title: t(`${G}.s5.title`, '5. Bir malzeme nerede kullanılıyor?'),
      text: t(`${G}.s5.text`, '"Nerede kullanılıyor" görünümünde "Malzeme seç" ile malzemeyi seçin. Liste, malzemeyi kullanan ürünleri reçete miktarı, fire %, reçete durumu (Aktif / Pasif) ve satır istisnasıyla gösterir.'),
      tips: [
        t(`${G}.s5.tip1`, '"Bunu kullananlar" bir üst seviyeye çıkar; üstteki yol üzerinden geri dönebilirsiniz. "Ağacı göster" o ürünün ağacını açar. Başlıktaki (i) bu rehberi yeniden açar.'),
      ],
    },
  ],
});
